import { render } from "./VerEvento.vue?vue&type=template&id=144fade2&scoped=true"
import script from "./VerEvento.vue?vue&type=script&lang=js"
export * from "./VerEvento.vue?vue&type=script&lang=js"

import "./VerEvento.vue?vue&type=style&index=0&id=144fade2&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144fade2"]])

export default __exports__